import type { IconSvgObject } from './types';

const PowerOffIcon: IconSvgObject = [
  ["path", { d: "M18.7083 6C20.1334 7.59227 21 9.69494 21 12C21 13.1856 20.7708 14.3176 20.3542 15.3542M5.29168 6C3.86656 7.59227 3 9.69494 3 12C3 16.9706 7.02944 21 12 21C14.4853 21 16.7353 19.9926 18.364 18.364", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 3L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 3L12 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PowerOffIcon;
